export const DEFERRED_RECOGNITION_TYPES = {
  REVENUE: "revenue",
  EXPENSE: "expense",
} as const;

export type DeferredRecognitionType =
  (typeof DEFERRED_RECOGNITION_TYPES)[keyof typeof DEFERRED_RECOGNITION_TYPES];

export const RECOGNITION_STATUS = {
  BOOKED: "BOOKED",
  RECOGNIZED: "RECOGNIZED",
  DEFERRED: "DEFERRED",
} as const;

export type RecognitionStatus =
  (typeof RECOGNITION_STATUS)[keyof typeof RECOGNITION_STATUS];
